export default "__VITE_ASSET__DWfUOVv$__"